import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonInput } from '@ionic/vue';
import { AutocompleteTypes, Color, TextFieldTypes } from '@ionic/core';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormInput',
  props: {
    accept: null,
    autocapitalize: null,
    autocomplete: null,
    autocorrect: null,
    autofocus: { type: Boolean },
    clearInput: { type: Boolean },
    clearOnEdit: { type: Boolean },
    color: null,
    debounce: null,
    disabled: { type: Boolean },
    enterkeyhint: null,
    fireFocusEvents: { type: Boolean },
    getInputElement: null,
    inputmode: null,
    max: null,
    maxlength: null,
    min: null,
    minlength: null,
    mode: null,
    multiple: { type: Boolean },
    name: null,
    pattern: null,
    placeholder: null,
    readonly: { type: Boolean },
    required: { type: Boolean },
    setBlur: null,
    setFocus: null,
    size: null,
    spellcheck: { type: Boolean },
    step: null,
    type: null,
    value: null
  },
  setup(__props: any) {



const focused = ref<boolean>(false);

const focusClass = computed<Array<string>>(() => (focused.value ? ['border-b-primary'] : ['border-b-medium']));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonInput), {
    class: _normalizeClass(["rounded-lg border-b-[1px] border-solid border-transparent text-sm", [..._unref(focusClass)]]),
    accept: __props.accept,
    autocapitalize: __props.autocapitalize,
    autocomplete: __props.autocomplete,
    autocorrect: __props.autocorrect,
    clearInput: __props.clearInput,
    clearOnEdit: __props.clearOnEdit,
    color: __props.color,
    debounce: __props.debounce,
    disabled: __props.disabled,
    enterkeyhint: __props.enterkeyhint,
    fireFocusEvents: __props.fireFocusEvents,
    getInputElement: __props.getInputElement,
    inputmode: __props.inputmode,
    max: __props.max,
    maxlength: __props.maxlength,
    min: __props.min,
    minlength: __props.minlength,
    mode: __props.mode,
    multiple: __props.multiple,
    name: __props.name,
    pattern: __props.pattern,
    placeholder: __props.placeholder,
    readonly: __props.readonly,
    required: __props.required,
    setBlur: __props.setBlur,
    setFocus: __props.setFocus,
    size: __props.size,
    spellcheck: __props.spellcheck,
    step: __props.step,
    type: __props.type,
    value: __props.value,
    onFocusin: _cache[0] || (_cache[0] = ($event: any) => (focused.value = true)),
    onFocusout: _cache[1] || (_cache[1] = ($event: any) => (focused.value = false))
  }, null, 8, ["class", "accept", "autocapitalize", "autocomplete", "autocorrect", "clearInput", "clearOnEdit", "color", "debounce", "disabled", "enterkeyhint", "fireFocusEvents", "getInputElement", "inputmode", "max", "maxlength", "min", "minlength", "mode", "multiple", "name", "pattern", "placeholder", "readonly", "required", "setBlur", "setFocus", "size", "spellcheck", "step", "type", "value"]))
}
}

})